import React, { useEffect } from "react";
import Header from "./Header/Header";
import "./AnalyticsScreen.scss";
import BasicReports from "./BasicReports/BasicReports";
import { fetchBasicAnalyticsRequest } from "../../../redux/exam_analytics/analyticsSlice";
import { useDispatch, useSelector } from "react-redux";
import { ClipLoader } from "react-spinners";
import { useLocation,useHistory  } from "react-router-dom";

const AnalyticsScreen = () => {
  const dispatch = useDispatch();
const history = useHistory();
const { testDetails } = useSelector((state) => state.examSlice);
const source = testDetails?.source;
  const paperId = useSelector((s) => s.examSlice.paperId);

  const { basicAnalytics, loading, error } = useSelector(
    (s) => s.analyticsSlice
  );
const location = useLocation();
useEffect(() => {
  if (location.state?.set_id) {
    dispatch(
      fetchBasicAnalyticsRequest({
        paper_type: location.state.paper_type,
        set_id: location.state.set_id,
      })
    );
  }
}, [location.state, dispatch]);

  const examSubmitted = useSelector(
  (s) => s.examSlice.examSubmitted
);

const apiData = basicAnalytics?.data;
const isScoreReady =
  apiData &&
  apiData.user_marks !== null &&
  apiData.total_marks !== null;


 
  if (loading?.basic) {
    return (
      <div className="analytics-loader">
        <ClipLoader color="#C61C26" size={55} />
      </div>
    );
  }

 
  if (error?.basic) {
    return (
      <div className="analytics-error">
        <p>Error: {error.basic}</p>
      </div>
    );
  }

  return (
    <div className="analytics-wrapper">
      {/* <Header paperName={apiData?.paper_name} />
      <BasicReports basicAnalytics={apiData} /> */}
      {/* <Header paperName={apiData?.paper_name} /> */}
      <Header
  paperName={apiData?.paper_name}
  onBack={() => {
    if (source === "topicwise") {
      history.push("/practice/topic-wise/pyqset");
    } else if (source === "yearwise") {
      history.push("/practice/paper-listing?type=Year Wise");
    } else {
      history.push("/practice/paper-listing");
    }
  }}
/>

{isScoreReady ? (
  <BasicReports basicAnalytics={apiData} />
) : (
  <div className="analytics-loader">
    <ClipLoader color="#C61C26" size={55} />
    <p>Preparing your scorecard...</p>
  </div>
)}

    </div>
  );
};

export default AnalyticsScreen;
